export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
}

export const GRAPHQL_EXTENSIONS_CODE = {
  BAD_REQUEST: 'BAD_REQUEST',
  FORBIDDEN: 'FORBIDDEN',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  DUPLICATE_RESOURCE: 'DUPLICATE_RESOURCE',
  RESOURCE_IN_USE: 'RESOURCE_IN_USE',
} as const

export enum GraphqlApi {
  Havelock = 'HAVELOCK',
  Prodactive = 'PRODACTIVE',
}
